module.exports = __webpack_public_path__ + "assets/map-image-f40ed5.png";


//////////////////
// WEBPACK FOOTER
// ./Content/images/map-image.png
// module id = 799
// module chunks = 2